import React, { useMemo } from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import { IBulletinFilterModel } from '@/types/admin/bulletins';
import { useResponsive } from '@/hooks/common/useResponsive';
import { TabSegment, type TabSegmentItem } from '@/components/shared/redesign';

export type RecipientType = IBulletinFilterModel['recipientType'];

interface BulletinRecipientTabsProps {
  activeRecipientType: RecipientType;
  onRecipientTypeChange: (recipientType: RecipientType) => void;
}

export const BulletinRecipientTabs: React.FC<BulletinRecipientTabsProps> = ({
  activeRecipientType,
  onRecipientTypeChange,
}) => {
  const { layoutMode } = useResponsive();
  const items = useMemo<TabSegmentItem<NonNullable<RecipientType>>[]>(
    () => [
      { key: 'all', label: 'All residents' },
      { key: 'current', label: 'Current residents' },
      { key: 'future', label: 'Future residents' },
      { key: 'notice', label: 'Lease notice' },
    ],
    [],
  );

  const handleChange = (key: NonNullable<RecipientType>) => onRecipientTypeChange(key);
  const selectedKey = (activeRecipientType ?? 'all') as NonNullable<RecipientType>;

  if (layoutMode === 'desktop') {
    return (
      <View style={styles.container}>
        <TabSegment<NonNullable<RecipientType>>
          items={items}
          selectedKey={selectedKey}
          onChange={handleChange}
          variant="pill"
        />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.scrollContent}
      >
        <TabSegment<NonNullable<RecipientType>>
          items={items}
          selectedKey={selectedKey}
          onChange={handleChange}
          variant="chip"
        />
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
  },
  scrollContent: {
    paddingHorizontal: 4,
    gap: 8,
  },
});
